export default function MassiaConfig($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('home');
    $translatePartialLoaderProvider.addPart('commun');
    $translatePartialLoaderProvider.addPart('errors');
}

MassiaConfig.$inject = ['$translatePartialLoaderProvider'];
